// Gateway configuration. Set REACT_APP_GRAPH_API_KEY in Vercel (Project → Settings →
// Environment Variables) and restrict the key to your domain in Subgraph Studio.
// NOTE: anything bundled into a CRA app is public; the env var only keeps the key out of git.
// The legacy key below is kept as a fallback so existing deploys keep working — rotate it.
const LEGACY_KEY = '66cd013cc62d3defadfa96f4f0a56431';
export const GRAPH_API_KEY = process.env.REACT_APP_GRAPH_API_KEY || LEGACY_KEY;
const GW = process.env.REACT_APP_GRAPH_GATEWAY || 'https://gateway.thegraph.com/api';

export const subgraphUrl = (id) => `${GW}/${GRAPH_API_KEY}/subgraphs/id/${id}`;
export const deploymentUrl = (id) => `${GW}/${GRAPH_API_KEY}/deployments/id/${id}`;

export const ENDPOINTS = {
  ethereum: {
    vesting: subgraphUrl('ChfAJn6jQEBjVqtdUiThfG6sWy2Sr5XQPNucE9DkgXSN'),
    network: deploymentUrl('QmV4L8TaKpVmCXwaMtckdbM85B454qTH3Vf9qo9sfRLqZc'),
  },
  arbitrum: {
    vesting: subgraphUrl('8nfKWzfgDT5z2LQgkrLCpyRdFWr8RPsXFJ91mA6PTNiW'),
    network: subgraphUrl('DZz4kDTdmzWLWsV373w2bSmoar3umKKH9y82SUKr5qmp'),
  },
};
